import moment from 'moment';
import BigNumber from 'bignumber.js';
import BASE_CONSTANTS from '@/constants/baseConstants';
import * as Sentry from '@sentry/vue';
const toFixed = (value, digits, floorOff) => {
    const factor = Math.pow(10, !digits ? 2 : digits);
    const interValue = floorOff ? value * factor : Math.floor(value * factor);
    return (interValue / factor).toFixed(digits);
};
BigNumber.config({
    EXPONENTIAL_AT: [-100, 100] // Диапазон, за пределами которого используется экспоненциальная нотация
});
export default {
    formatMoney: function (value, notFixed) {
        const str = ('' + value).split('.');
        if (!notFixed)
            return `${str[0].replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + ' ')}${str[1] ? ',' + str[1] : ',00'}`;
        return `${str[0].replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + ' ')}`;
    },
    formatMoneyLogged: function (value, place, notFixed) {
        const str = ('' + value).split('.');
        if (str.includes('NaN')) {
            // @ts-ignore
            Sentry.captureException(new Error('NaN formatMoney'), { extra: { item: value, place } });
        }
        if (!notFixed)
            return `${str[0].replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + ' ')}${str[1] ? ',' + str[1] : ',00'}`;
        return `${str[0].replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + ' ')}`;
    },
    formatToCurrency: (value, currency, floorOff) => {
        return BigNumber(value).toFixed(currency.toLowerCase() === 'usdt' ? 2 : 8, 1).toString();
    },
    formatToCurrencyMainWidgets: (value, currency) => {
        const decimalPlaces = BASE_CONSTANTS.ASSETS_FIXED_ZEROS_QUANTITY[currency.toUpperCase()];
        if (!decimalPlaces)
            console.log(currency);
        const ceilNumberQuantity = BigNumber(value).integerValue(BigNumber.ROUND_CEIL).toString().length;
        const preciseQuantity = ceilNumberQuantity + decimalPlaces;
        return BigNumber(BigNumber(value).toFixed(decimalPlaces, 1)).precision(preciseQuantity, 1).toString();
    },
    formatDateTime: (value, format) => {
        return moment(value).format(format);
    },
    toUppercase: (value) => value.toUpperCase(),
    toLowerCase: (value) => value.toLowerCase(),
    capitalizeFirstLetter: (value) => value.charAt(0).toUpperCase() + value.slice(1),
    fixString: (value, maxLength) => {
        if (value.length > maxLength)
            return value.substring(0, maxLength - 3) + '...';
        return value !== null && value !== void 0 ? value : '';
    },
    toFixed,
    removeExtraZero: (val) => String(parseFloat(val)).replace(/\./g, ','),
    removeTrailingZeros: (val, separator = '.') => {
        const splittedString = val.split(separator);
        if (BigNumber(splittedString.join('.')).isZero()) {
            return '0';
        }
        if (splittedString.length === 1)
            return val;
        const [integerPart, floatPart] = splittedString;
        const trailingZerosPattern = /0+$/;
        const floatWithoutZeroes = floatPart.replace(trailingZerosPattern, '');
        if (floatWithoutZeroes.length === 0) {
            return integerPart;
        }
        return integerPart + separator + floatWithoutZeroes;
    },
    replaceDot: (val, by = ',') => {
        return val.replace(/\./g, by);
    },
    formatNS: (val, method, params = null) => val[method](params)
};
